export const fields = {
  token: {
    type: "token",
    name: "verification_code",
    label: "informe o código recebido"
  }
}
